import {
  PaymentControllerService,
  PaymentMasterInfoVo,
} from '@/__generated__/CommonApi';
import {
  myMissHistoryVo,
  MySupportHistoryControllerService,
  myMissModuleVo,
} from '@/__generated__/FrontApi';
import Button, { BtnClose } from '@/components/Button';
import { PopCcontainer, PopupTitle } from '@/components/Css/Pop';
import ErrorMessage from '@/components/Form/ErrorMessage';
import FormGroup, { FormItem } from '@/components/Form/FormGroup';
import LabelText from '@/components/Form/LabelText';
import InputRadio, { InputRadioGroup } from '@/components/Input/InputRadio';
import InputText from '@/components/Input/InputText';
import Select from '@/components/Select';
import Modal, { ModalProps } from '@/components/Modal';
import ListSkeleton from '@/components/Mypage/ListSkeleton';
import { NotiBox, NotiItem, NotiList } from '@/components/Text/TextNoti';
import InicisMobileOnceForm, {
  InicisMobileOnceRef,
} from '@/components/ThirdParty/InicisMobileOnceForm';
import InicisPcOnceForm, {
  InicisPcOnceRef,
} from '@/components/ThirdParty/InicisPcOnceForm';
import KcpMobileForm, {
  KcpMobileRef,
} from '@/components/ThirdParty/KcpMobileForm';
import KcpPcForm, { KcpPcRef } from '@/components/ThirdParty/KcpPcForm';
import MobiliansOnceForm, {
  MobiliansOnceRef,
} from '@/components/ThirdParty/MobiliansOnceForm';
import NaverPayForm, {
  NaverPayRef,
} from '@/components/ThirdParty/NaverPayForm';
import { H3, H4, Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { isMobileDevice } from '@/helpers/BrowserHelper';
import PaymentHelper, {
  INICIS_PAY_METHOD_MOBILE_MAP,
  INICIS_PAY_METHOD_PC_MAP,
  KCP_PAY_METHOD_MOBILE_MAP,
  KCP_PAY_METHOD_PC_MAP,
  KCP_BANK_MAP,
  PAYTYPE_ONCE_BANKING,
  PAYTYPE_ONCE_CARD,
  PAYTYPE_ONCE_NAVERPAY,
  PAYTYPE_ONCE_PHONE,
  getPgType,
  getKcpVaDate,
  formatVaDate,
} from '@/helpers/PaymentHelper';
import SessionStorage from '@/services/SessionStorage';
import { usePopupStore } from '@/stores/PopupStore';
import { useLocation } from '@reach/router';
import axios from 'axios';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';

const VcntInfoList = styled.ul`
  padding: 16px 0 0 0;
  li {
    padding-left: 96px;
    position: relative;
    line-height: 28px;
    & + li {
      margin-top: 8px;
    }
  }
  span {
    color: #2d2926;
    font-weight: bold;
    position: absolute;
    left: 0;
    top: 0;
  }
  ${breakpoint(`mobile`)} {
    li {
      padding-left: 80px;
    }
  }
`;
const VcntInfoItem = styled.li``;

const HistoryList = styled.ul``;
const HistoryItem = styled.li`
  display: table;
  width: 100%;
  table-layout: fixed;
  padding: 32px 0;
  position: relative;
  border-bottom: 1px solid #b7b8ba;
  ${breakpoint(800)} {
    display: block;
    padding: 24px 0;
  }
  ${Button} {
    width: 160px;
    ${breakpoint(`mobile`)} {
      width: initial;
    }
  }
`;
const InputTextCustom = styled.div<{ active?: boolean }>`
  border: 1px solid #e5e6e8;
  margin-top: -1px;
  ${({ active }) => {
    if (!active) {
      return `
            span {
              color: #2d2926 !important;
            }
          `;
    }
    return ``;
  }}
`;
const Tip = styled.p`
  color: #828385;
  font-size: 14px;
  font-weight: normal;
`;
const Month = styled.div``;
const Category = styled.div`
  min-height: 44px;
  line-height: 2;
  color: #828385;
  strong {
    color: #1cabe2;
    display: inline-block;
    margin-left: 40px;
    &.first {
      margin-left: 0;
    }
  }
  ${Button} {
    margin-left: 32px;
    ${breakpoint(640)} {
      display: block;
      margin-left: 90px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
    }
  }
  ${breakpoint(640)} {
    margin-top: 18px;
  }
`;
const PriceDetail = styled.div`
  margin-top: 18px;
  span {
    position: relative;
    padding-right: 16px;
    &.is-failed {
      color: #e2231a;
    }
    & + span {
      padding-left: 16px;
      &::before {
        content: '';
        display: block;
        width: 1px;
        height: 16px;
        background: #e5e6e8;
        position: absolute;
        left: 0;
        top: 5px;
      }
    }
  }
`;
const Cell = styled.div<{
  type?: string;
  status?: string;
  price?: boolean;
  parentClassName?: string;
}>`
  display: table-cell;

  ${InputTextCustom} {
    span {
      width: 10%;
      text-align: right;
      color: #b7b8ba;
    }
  }
  ${breakpoint(800)} {
    ${(props) => {
      if (props.parentClassName === 'module-missHistory') {
        return ``;
      }
      return `
        display: block;
      `;
    }}

    ${({ status }) => {
      if (status === `dark` || status === `light`) {
        return `
            position: absolute;
            right: 0;
            top: 24px;
            font-size: 16px;
            text-align: right;
            white-space: nowrap;
          `;
      }
      return ``;
    }}

    ${({ type, ...props }) => {
      if (type === `date`) {
        if (props.parentClassName === 'module-missHistory') {
          return `
            // Styles for 'module-missHistory'
          `;
        }
        return `
          text-align: left;
          width: 100%;
          font-size: 16px;
        `;
      }
      if (type === `status`) {
        if (props.parentClassName === 'module-missHistory') {
          return `
            // Styles for 'module-missHistory'
            ${Button} {
              background: pink;
            }
          `;
        }
        return `
          position: absolute;
          right: 0;
          top: 24px;
          font-size: 16px;
          text-align: right;
          white-space: nowrap;
          width: 100%;
        `;
      }
      if (props.parentClassName === 'module-missHistory') {
        return `
          // Styles for 'module-missHistory'
        `;
      }
      return `padding-left: 0;`;
    }}
  }

  ${breakpoint(`mobile`)} {
    ${(props) => {
      if (props.parentClassName === 'module-missHistory') {
        return `
          padding-left: 0;
          ${Category} {
            margin-top: 0;
          }
        `;
      }
      return ``;
    }}

    ${({ type, ...props }) => {
      if (type === `date`) {
        if (props.parentClassName === 'module-missHistory') {
          return `
            font-size: 14px;
            width: 24%;
            text-align: left;
          `;
        }
        return ``;
      }
      if (type === `status`) {
        if (props.parentClassName === 'module-missHistory') {
          return `
            display: block;
            width: 100%;
            ${Button} {
              width: 100%;
            }
          `;
        }
        return ``;
      }
      return ``;
    }}
  }

  ${({ type }) => {
    if (type === `date` || type === `status`) {
      return `
            width: 15%;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            .sky {
              color: #1cabe2
            }
          `;
    }
    if (type === `reward`) {
      return `
        font-size: 16px;   
        width: 10%;   
        color: #828385;
      `;
    }
    if (type === `address`) {
      return `  
        width: 20%;
        text-align: right;   
        vertical-align: middle;
        ${Tip} {
          color: #828385 !important;
          margin-top: 16px;
        }
      `;
    }
    return `padding-left: 24px;`;
  }}
  ${({ price }) => {
    if (price) {
      return `
            width: 40%;
            padding-right: 16px;
            ${InputText} {
              border: none;
              width: 90%;
              display: inline-block;
            }
          `;
    }
    return ``;
  }}
  ${({ status }) => {
    if (status === `dark`) {
      return `
            color: #2d2926
          `;
    }
    if (status === `light`) {
      return `
            color: #828385;
          `;
    }
    return ``;
  }}
`;
const NoData = styled.div`
  text-align: center;
  border-top: 1px solid #e5e6e8;
  border-bottom: 1px solid #e5e6e8;
  padding: 96px 0;
  ${H3} {
    line-height: 1.7;
  }
  ${breakpoint(640)} {
    ${H3} {
      font-size: 14px;
      line-height: 28px;
    }
  }
`;
const Container = styled.div`
  // Style for 'module-missHistory'

  ${(props) =>
    props.className === 'module-missHistory' &&
    `
      ${HistoryList} {
        height: 460px;
        overflow: auto;
        ${HistoryItem} {
          &:first-child {
            border-top: 1px solid #b7b8ba;
          }
          table-layout: auto;
          padding: 20px 0;
          ${Cell} {
            vertical-align: top;
          }
          ${Category} {
            min-height: initial;
            line-height: 1.4;
            display: flex;
            align-items: flex-start;
            strong {
              flex: 0 0 140px;
              margin-left: 30px;
              word-break: keep-all;
            }
          }
          ${Month} {
            line-height: 1;
            margin-top: 0;
          }
          ${PriceDetail} {
            margin-top: 10px;
          }
          ${Button} {
            width: 100px;
            background: #ffdc0e;
            border-color: #ffdc0e;
            color: #2d2926;
          }
        }
      }

      ${breakpoint(`mobile`)} {
      
        ${HistoryList} {
          height: auto;
          overflow: visible;
          
          ${HistoryItem} {
            display: flex;
            flex-wrap: wrap;

            ${Month} {
              margin-top: 0;
            }
            ${Button} {
              width: 100%;
              margin-top: 30px;
              font-size: 14px;
            }
          }
        }

      }
    `}
`;
const PAY_KIND_MAP: { [key: string]: string } = {
  CMS: `자동이체`,
  Card: `카드`,
  'Naver Pay': `네이버페이(Npay)`,
  VAccount: `무통장입금`,
};

interface PaymentFormData {
  paymentType: string;
  vaBankCode?: string;
  vaName?: string;
}

interface PaymentModalProps extends ModalProps {
  onRequestPay: (paymentType: string, vaBankCode?: string, vaName?: string) => void;
  confPgType: string;
  isProcessing?: boolean;
  estimatedAmount?: number;
}

interface PgCommonRefProps {
  moduleYn: string;
  missModuleCode: string;
  solicitCode: string;
  completeUrl: string;
}

const PaymentModal: FC<PaymentModalProps> = ({
  onRequestClose,
  onRequestPay,
  confPgType,
  isProcessing,
  estimatedAmount,
  ...props
}) => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm<PaymentFormData>();
  const isCardDisabled = (estimatedAmount || 0) < 1000;
  const {
    allBank: { nodes: banks },
  } = useStaticQuery(graphql`
    query {
      allBank {
        nodes {
          code
          description
        }
      }
    }
  `);
  const paymentType = watch('paymentType', isCardDisabled ? PAYTYPE_ONCE_BANKING : PAYTYPE_ONCE_CARD);

  const onSubmit: SubmitHandler<PaymentFormData> = useCallback(
    ({ paymentType, vaBankCode, vaName }) => {
      onRequestPay(paymentType, vaBankCode, vaName);
    },
    [onRequestPay],
  );

  return (
    <Modal
      dismissable={!isProcessing}
      maxWidth="500px"
      onRequestClose={onRequestClose}
      {...props}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <PopCcontainer>
          <PopupTitle>
            <h2>
              <Tit size="s3" color="sky">
                후원금 납입 방법을 선택해주세요
              </Tit>
            </h2>
            <BtnClose onClick={onRequestClose}>
              <span className="a11y">닫기</span>
            </BtnClose>
          </PopupTitle>
          <FormItem
            noBorder
            css={`
              padding: 20px 0 !important;
            `}
          >
            <FormGroup>
              <H4>납입방법</H4>
              <InputRadioGroup full>
                <InputRadio
                  name="paymentType"
                  ref={register}
                  tab
                  value={PAYTYPE_ONCE_CARD}
                  label="신용카드"
                  defaultChecked={!isCardDisabled}
                  disabled={isCardDisabled}
                />
                {/* <InputRadio
                  name="paymentType"
                  ref={register}
                  tab
                  value={PAYTYPE_ONCE_PHONE}
                  label="휴대폰"
                /> */}
                <InputRadio
                  name="paymentType"
                  ref={register}
                  tab
                  value={PAYTYPE_ONCE_BANKING}
                  label="무통장입금"
                  defaultChecked={isCardDisabled}
                />
                <InputRadio
                  name="paymentType"
                  ref={register}
                  tab
                  value={PAYTYPE_ONCE_NAVERPAY}
                  label="네이버페이(Npay)"
                />
              </InputRadioGroup>
            </FormGroup>
            {/* KCP 가상계좌 - 은행/입금자 입력 */}
            {paymentType === PAYTYPE_ONCE_BANKING && confPgType === 'KCP' && (
              <>
                <FormGroup>
                  <LabelText require>입금 은행</LabelText>
                  <Select
                    name="vaBankCode"
                    ref={register({
                      required: {
                        value:
                          paymentType === PAYTYPE_ONCE_BANKING &&
                          confPgType === 'KCP',
                        message: `필수 입력입니다`,
                      },
                    })}
                  >
                    <option value="">은행 선택</option>
                    {banks
                      .filter((bank: { code: string }) => KCP_BANK_MAP[bank.code])
                      .map((bank: { code: string; description: string }) => (
                        <option key={bank.code} value={bank.code}>
                          {bank.description}
                        </option>
                      ))}
                  </Select>
                  {errors.vaBankCode && (
                    <ErrorMessage>{errors.vaBankCode.message}</ErrorMessage>
                  )}
                </FormGroup>
                <FormGroup>
                  <LabelText require>입금자명</LabelText>
                  <InputText
                    name="vaName"
                    ref={register({
                      required: {
                        value:
                          paymentType === PAYTYPE_ONCE_BANKING &&
                          confPgType === 'KCP',
                        message: `필수 입력입니다`,
                      },
                    })}
                    placeholder="입금자명 입력"
                  />
                  {errors.vaName && (
                    <ErrorMessage>{errors.vaName.message}</ErrorMessage>
                  )}
                </FormGroup>
              </>
            )}
            <FormGroup>
              <Button type="submit" full disabled={isProcessing}>
                {isProcessing
                  ? '진행 중입니다. 잠시 기다려 주세요'
                  : paymentType === PAYTYPE_ONCE_BANKING && confPgType === 'KCP'
                    ? '납부하기'
                    : '선택'}
              </Button>
              {isCardDisabled && (
                <p css={`color: #e2231a; font-size: 14px; margin-top: 8px;`}>
                  신용카드는 1천 원 이상부터 납부가 가능하오니 다른 결제 수단을 이용해 주세요.
                </p>
              )}
            </FormGroup>
          </FormItem>
        </PopCcontainer>
      </form>
    </Modal>
  );
};

interface MyPageSupportHistoryTab2Props {
  params: URLSearchParams;
  className?: string;
  moduleInfo?: myMissModuleVo;
}

const MyPageSupportHistoryTab2: FC<MyPageSupportHistoryTab2Props> = ({
  params,
  className,
  moduleInfo,
  ...props
}) => {
  const confPgType = process.env.PG_TYPE_DONATE || 'KCP'; // 후원하기 페이지용 PG사
  const popupStore = usePopupStore();
  const [items, setItems] = useState<myMissHistoryVo[]>([]);
  const [loading, setLoading] = useState(true);
  const [payingItem, setPayingItem] = useState<myMissHistoryVo>();
  const [isProcessing, setIsProcessing] = useState(false);
  const inicisPcRef = useRef<InicisPcOnceRef>(null);
  const inicisMobileRef = useRef<InicisMobileOnceRef>(null);
  const kcpPcRef = useRef<KcpPcRef>(null);
  const kcpMobileRef = useRef<KcpMobileRef>(null);
  const naverRef = useRef<NaverPayRef>(null);
  const mobiliansRef = useRef<MobiliansOnceRef>(null);
  const loadItems = useCallback(async () => {
    try {
      const {
        data,
      } = await MySupportHistoryControllerService.getMyMissSupportHistoryUsingPost(
        {
          pathType: moduleInfo ? `MISSMODULE` : `SUPPORT`,
        },
      );
      setItems(data as myMissHistoryVo[]);
    } finally {
      setLoading(false);
    }
  }, [moduleInfo]);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  // 미납후원 완료 팝업
  useEffect(() => {
    if (params.get(`orderNumber`)) {
      popupStore.show(`놓친 후원이 성공적으로 완료되었습니다.`);

      if (moduleInfo) {
        setPayingItem(undefined);
        loadItems();
        // url에서 orderNumber 삭제
        navigate(
          `/donate/overdue/?cpCode=${moduleInfo?.urlKeyword}`,
        );
      } else {
        // url에서 orderNumber 삭제
        navigate(`/mypage/support-history?tabIndex=1`);
      }
    }
  }, [params, popupStore]);

  // 납부
  const pay = useCallback(
    async (paymentType: string, item: myMissHistoryVo, vaBankCode?: string, vaName?: string) => {
      setIsProcessing(true);
      // 모듈 때문에 분기
      const moduleYn = moduleInfo ? 'Y' : 'N';
      const missModuleCode = moduleInfo?.moduleCode;
      const solicitCode = moduleInfo?.solicitCode;
      const updatedItem = { ...item };
      if (moduleInfo) {
        updatedItem.rUrl = `${process.env.SELF_URL}/donate/overdue/?cpCode=${moduleInfo.urlKeyword}`;
      } else {
        updatedItem.rUrl = `${process.env.SELF_URL}/mypage/support-history/?tabIndex=1`;
      }
      const pgCommonParam = {
        moduleYn: moduleYn || '',
        missModuleCode: missModuleCode || '',
        solicitCode: solicitCode || '',
        completeUrl: updatedItem.rUrl,
      } as PgCommonRefProps;
      try {
        const {
          data,
          resultCode,
        } = await PaymentControllerService.paymentInfoSetGiftIdUsingPost({
          deviceType: isMobileDevice() ? `MOBILE` : `PC`,
          donationId: item.donationId,
          estimatedAmount: item.estimatedAmount,
          paymentTypeCode: paymentType,
          successUrl: updatedItem.rUrl,
          // PG 변경에 따른 값 추가
          pgType: getPgType(confPgType, `${paymentType}`),
          trackcode: params.get(`trackcode`) || '',
          pathType: moduleInfo ? `MISSMODULE` : `SUPPORT`,
          moduleCode: moduleInfo?.moduleCode || '',
          solicitCode: moduleInfo?.solicitCode || '',
        });
        const resData = data as any;
        // paymentInfo의 resultCode까지 success여야함
        if (
          resultCode === `success` &&
          resData?.paymentInfo?.resultCode === `success`
        ) {
          const giftInfo = resData.giftInfo as PaymentMasterInfoVo;
          const paymentInfo = resData.paymentInfo as any;
          const {
            orderNumber,
            mkey,
            signature,
            timestamp,
            orderToken,
            kcpInfo,
          } = paymentInfo;

          // 주문토큰 저장
          SessionStorage.setItem(`orderToken`, orderToken);
          // KCP 가상계좌 HUB API 직접 호출 (팝업 없음)
          if (paymentType === PAYTYPE_ONCE_BANKING && confPgType === 'KCP') {
            try {
              const vaRes = await axios.post(
                `${process.env.BACKEND_URL}/unicef/api/fo/common/payment/reqKcpVcntHub`,
                {
                  ordr_idxx: orderNumber,
                  amount: String(giftInfo?.totalAmount || 0),
                  good_name: giftInfo?.productName || '',
                  buyr_name: giftInfo?.memberName || '',
                  buyr_tel2: giftInfo?.mobilePhoneNumber || '',
                  buyr_mail: giftInfo?.emailDec || '',
                  va_bankcode: KCP_BANK_MAP[vaBankCode || ''],
                  bank_code: vaBankCode || '',
                  va_name: vaName || giftInfo?.memberName || '',
                  va_date: getKcpVaDate(3),
                },
              );
              if (vaRes.data.resultCode === 'success') {
                const vcnt = vaRes.data.data;
                setPayingItem(undefined);
                popupStore.show(
                  (
                    <>
                      <Tit size="s4" color="sky" css={`margin-bottom: 16px; display: block;`}>
                        가상계좌가 발급되었습니다.
                      </Tit>
                      <VcntInfoList>
                        <VcntInfoItem>
                          <span>입금 은행</span>
                          {vcnt.bankname || ''}
                        </VcntInfoItem>
                        <VcntInfoItem>
                          <span>가상계좌번호</span>
                          {vcnt.account || ''}
                        </VcntInfoItem>
                        <VcntInfoItem>
                          <span>입금기한</span>
                          {formatVaDate(vcnt.va_date)}
                        </VcntInfoItem>
                        <VcntInfoItem>
                          <span>입금금액</span>
                          {Number(vcnt.amount || 0).toLocaleString()}원
                        </VcntInfoItem>
                      </VcntInfoList>
                    </>
                  ) as any,
                  {
                    onConfirm: () => loadItems(),
                  },
                );
              } else {
                alert(
                  vaRes.data.resultMessage || '가상계좌 발급에 실패했습니다.',
                );
              }
            } catch (e: any) {
              if (e.response) {
                alert(
                  e.response.data?.resultMessage ||
                    '가상계좌 발급에 실패했습니다.',
                );
              }
            }
            return;
          }
          // PG사별 결제진행
          if ([PAYTYPE_ONCE_CARD, PAYTYPE_ONCE_BANKING].includes(paymentType)) {
            // 모바일이면
            if (isMobileDevice()) {
              if (confPgType === 'KCP') {
                if (
                  !orderNumber ||
                  !kcpInfo?.siteId ||
                  !kcpInfo?.siteName ||
                  !kcpInfo?.approvalKey ||
                  !kcpInfo?.traceNo ||
                  !kcpInfo?.payUrl ||
                  !kcpInfo?.retUrl
                ) {
                  popupStore.show(`주요정보가 넘어오지 않았습니다`);
                  return;
                }
                kcpMobileRef.current?.init({
                  ...pgCommonParam,
                  pgProc: 'pay',
                  siteCd: kcpInfo?.siteId,
                  siteName: kcpInfo?.siteName,
                  siteLogo: kcpInfo?.siteLogo || '',
                  approvalKey: kcpInfo?.approvalKey,
                  traceNo: kcpInfo?.traceNo,
                  payUrl: kcpInfo?.payUrl,
                  retUrl: kcpInfo?.retUrl,
                  payMethod: KCP_PAY_METHOD_MOBILE_MAP[paymentType],
                  goodname: giftInfo?.productName || '',
                  buyername: giftInfo?.memberName || '',
                  price: giftInfo?.totalAmount || 0,
                  oid: orderNumber,
                  failUrl: window.location.href,
                  currency: '',
                  buyertel: giftInfo.mobilePhoneNumber || ``,
                  buyeremail: giftInfo?.emailDec || '',
                });
              } else {
                if (!orderNumber) {
                  console.error(`주요정보가 넘어오지 않았습니다`);
                  return;
                }
                inicisMobileRef.current?.init({
                  ...pgCommonParam,
                  payMethod: INICIS_PAY_METHOD_MOBILE_MAP[paymentType],
                  goods: giftInfo.productName,
                  uname: giftInfo.memberName,
                  amt: giftInfo.totalAmount || 0,
                  oid: orderNumber,
                  trackcode: params.get(`trackcode`),
                });
              }
            } else {
              // eslint-disable-next-line no-lonely-if
              if (confPgType === 'KCP') {
                if (
                  !orderNumber ||
                  !kcpInfo?.siteId ||
                  !kcpInfo?.siteName ||
                  !kcpInfo?.jsPlugin
                ) {
                  popupStore.show(`주요정보가 넘어오지 않았습니다`);
                  return;
                }
                kcpPcRef.current?.init({
                  ...pgCommonParam,
                  pgProc: 'pay',
                  siteCd: kcpInfo?.siteId,
                  siteName: kcpInfo?.siteName,
                  siteLogo: kcpInfo?.siteLogo || '',
                  jsPluginUrl: kcpInfo?.jsPlugin,
                  payMethod: KCP_PAY_METHOD_PC_MAP[paymentType],
                  goodname: giftInfo?.productName || '',
                  buyername: giftInfo?.memberName || '',
                  buyeremail: giftInfo?.emailDec || '',
                  buyertel: giftInfo.mobilePhoneNumber || ``,
                  price: giftInfo?.totalAmount || 0,
                  oid: orderNumber,
                  failUrl: window.location.origin,
                  currency: '',
                });
              } else {
                if (!orderNumber || !mkey || !signature || !timestamp) {
                  console.error(`주요정보가 넘어오지 않았습니다`);
                  return;
                }
                inicisPcRef.current?.init({
                  ...pgCommonParam,
                  payMethod: INICIS_PAY_METHOD_PC_MAP[paymentType],
                  goodname: giftInfo.productName,
                  buyername: giftInfo.memberName,
                  buyeremail: giftInfo.emailDec,
                  buyertel: giftInfo.mobilePhoneNumber,
                  price: giftInfo.totalAmount || 0,
                  mKey: mkey,
                  oid: orderNumber,
                  signature,
                  timestamp,
                  gender: '',
                  missUserId: '',
                });
              }
            }
          } else if (paymentType === PAYTYPE_ONCE_NAVERPAY) {
            // 네이버 결제
            if (!orderNumber) {
              console.error(`주요정보가 넘어오지 않았습니다`);
              return;
            }
            naverRef.current?.payNormal({
              productCount: 1,
              productName: giftInfo.productName || '',
              totalPayAmount: giftInfo.totalAmount || 0,
              taxScopeAmount: 0,
              taxExScopeAmount: giftInfo.totalAmount || 0,
              merchantPayKey: orderNumber,
              merchantUserKey: giftInfo.memberName,
            });
          }
          // 모빌리언스 휴대폰 결제
          else if (paymentType === PAYTYPE_ONCE_PHONE) {
            mobiliansRef.current?.init({
              goodname: giftInfo.productName,
              price: giftInfo.totalAmount || 0,
              oid: orderNumber,
            });
          }
        }
        // 실패면서 오류메세지 있다면
        else if (paymentInfo?.resultMessage) {
          // 결제쪽 오류메세지 출력 (이미 모달이어서 window.alert 사용)
          alert(data?.paymentInfo?.resultMessage);
        }
      } catch (e: any) {
        console.log('>> Exception : ', e);
        if (e.response) {
          // (이미 모달이어서 window.alert 사용)
          alert(e.response.data.resultMessage);
        }
      } finally {
        setIsProcessing(false);
      }
    },
    [],
  );

  return (
    <Container className={className} {...props}>
      <HistoryList>
        {loading && <ListSkeleton />}
        {!loading && items.length > 0 &&
          items.map((item) => (
            <HistoryItem key={item.donationId}>
              <Cell type="date" parentClassName={className}>
                <Month>{item.paymonth}</Month>
              </Cell>
              <Cell parentClassName={className}>
                <Category>
                  {item.pledgeId ? `정기후원` : `일시후원`}
                  {` `}
                  <strong>
                    {item.description}
                    {item.cdDescriptionDetail &&
                      ` [${item.cdDescriptionDetail}]`}
                  </strong>
                </Category>
                <PriceDetail>
                  <span>{Number(item.estimatedAmount).toLocaleString()}원</span>
                  <span>{PAY_KIND_MAP[item.kind || '']}</span>
                  <span className="is-failed">{item.statDesc}</span>
                </PriceDetail>
              </Cell>
              <Cell type="status" parentClassName={className}>
                <Button size="sm" disabled={isProcessing} onClick={() => setPayingItem(item)}>
                  납부하기
                </Button>
              </Cell>
            </HistoryItem>
          ))}
        {!loading && items.length === 0 && (
          <>
            {useLocation().pathname.indexOf('/donate/overdue') < 0 ? (
              <NoData>
                <H3>후원내역이 없습니다.</H3>
              </NoData>
            ) : (
              <NoData>
                <H3>놓친 후원내역이 없습니다.</H3>
              </NoData>
            )}
          </>
        )}
      </HistoryList>
      {moduleInfo?.infoMessage && (
        <NotiBox
          css={`
            margin-top: 24px;
            margin-bottom: 0;
          `}
        >
          <NotiList>
            <NotiItem>{moduleInfo?.infoMessage}</NotiItem>
          </NotiList>
        </NotiBox>
      )}

      {payingItem && (
        <PaymentModal
          onRequestPay={(paymentType, vaBankCode, vaName) => pay(paymentType, payingItem, vaBankCode, vaName)}
          onRequestClose={() => { if (!isProcessing) setPayingItem(undefined); }}
          confPgType={confPgType}
          isProcessing={isProcessing}
          estimatedAmount={Number(payingItem.estimatedAmount)}
        />
      )}
      {confPgType === 'KCP' ? (
        <>
          <KcpPcForm ref={kcpPcRef} />
          <KcpMobileForm ref={kcpMobileRef} />
        </>
      ) : (
        <>
          <InicisPcOnceForm ref={inicisPcRef} />
          <InicisMobileOnceForm ref={inicisMobileRef} />
        </>
      )}
      <NaverPayForm ref={naverRef} />
      <MobiliansOnceForm ref={mobiliansRef} />
    </Container>
  );
};

export default MyPageSupportHistoryTab2;
